import React, { useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { INSIDE_IMAGES } from '../data/product';
export function LookInside() {
  const trackRef = useRef<HTMLDivElement>(null);
  const [active, setActive] = useState(0);
  const scrollTo = (index: number) => {
    const track = trackRef.current;
    if (!track) return;
    const clamped = Math.max(0, Math.min(INSIDE_IMAGES.length - 1, index));
    const slide = track.children[clamped] as HTMLElement | undefined;
    if (slide) {
      track.scrollTo({
        left: slide.offsetLeft - track.offsetLeft,
        behavior: 'smooth'
      });
    }
    setActive(clamped);
  };
  const handleScroll = () => {
    const track = trackRef.current;
    if (!track) return;
    const index = Math.round(track.scrollLeft / track.clientWidth);
    setActive(Math.max(0, Math.min(INSIDE_IMAGES.length - 1, index)));
  };
  return <section id="look-inside" className="bg-navy px-4 py-6 sm:py-8" data-id="element-86" data-mp="1dx6o0dalt3ef">
      <div className="mx-auto max-w-5xl" data-id="element-87" data-mp="1dzj22fd8qtm7">
        <h2 className="text-center text-2xl text-white sm:text-4xl" data-id="element-88" data-mp="a24vhzg98nez">
          LOOK INSIDE
        </h2>
        <p className="mt-1 text-center font-display text-lg uppercase tracking-wide text-cyan sm:text-2xl" data-id="element-89" data-mp="61ug5w6kokng">
          Discover What&apos;s Inside AUTOMOTIVE DIAGNOSTIC PRO™
        </p>
        <p className="mx-auto mt-2 max-w-3xl text-center text-sm font-medium leading-snug text-white/80" data-id="element-90" data-mp="f20s3dmmhcki">
          Visual diagnostic workflows, testing sequences, electrical diagrams,
          DTC references, scan-data guides, symptom-based decision trees,
          network diagnostics and ready-to-use workshop tools.
        </p>

        <div className="relative mt-4" data-id="element-91" data-mp="12rnlb7s46wd">
          <div ref={trackRef} onScroll={handleScroll} className="no-scrollbar flex snap-x snap-mandatory gap-3 overflow-x-auto scroll-smooth" data-id="element-92" data-mp="13t07k4g11g7">
            {INSIDE_IMAGES.map(image => <a key={image.src} href="#offer" className="w-full shrink-0 snap-center" data-id="element-93" data-mp="2zsrsip1yx396">
                <img src={image.src} alt={image.alt} className="mx-auto w-full max-w-2xl rounded-lg border border-cyan/25 shadow-[0_14px_36px_-16px_rgba(0,0,0,0.8)]" loading="lazy" data-id="element-94" data-mp="13mr2rjz3lwa6" />
              </a>)}
          </div>

          <button type="button" onClick={() => scrollTo(active - 1)} aria-label="Previous page" className="absolute left-0 top-1/2 -translate-y-1/2 rounded-full border-2 border-cyan bg-navy/90 p-2 text-cyan transition-colors duration-150 hover:bg-cyan hover:text-navy" data-id="element-95" data-mp="kpzdmtwvkmy7">
            <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-96" data-mp="yq0mavjdsyo8" />
          </button>
          <button type="button" onClick={() => scrollTo(active + 1)} aria-label="Next page" className="absolute right-0 top-1/2 -translate-y-1/2 rounded-full border-2 border-cyan bg-navy/90 p-2 text-cyan transition-colors duration-150 hover:bg-cyan hover:text-navy" data-id="element-97" data-mp="256cfsjb9dsdh">
            <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-98" data-mp="2fb2kgwy1rale" />
          </button>
        </div>

        <div className="mt-3 flex items-center justify-center gap-2" data-id="element-99" data-mp="2ahq6rhuwoo7f">
          {INSIDE_IMAGES.map((image, index) => <button key={image.src} type="button" onClick={() => scrollTo(index)} aria-label={`Go to page ${index + 1}`} aria-current={index === active} className={`h-2.5 rounded-full transition-[width,background-color] duration-150 ${index === active ? 'w-7 bg-cyan' : 'w-2.5 bg-white/30'}`} data-id="element-100" data-mp="26fd3r17jn4ec" data-mpi={index} />)}
        </div>
        <p className="mt-1.5 text-center font-mono text-[11px] uppercase tracking-wider text-white/60" data-id="element-101" data-mp="3lypvy4lyimx8">
          {active + 1} / {INSIDE_IMAGES.length}
        </p>
      </div>
    </section>;
}